import React, { useEffect } from 'react';
import { Redirect, Route, } from 'react-router-dom';
import { isPlatform } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { observer } from 'mobx-react-lite';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { AuthSingleton } from '../../utils/AuthSingleton';
import { AuthenticationService } from '../../services/authentication.service';
import { VaultService } from '../../services/vault.service';
import { AuthProvider, useAuthService } from '../../services/Auth';
import { VaultProvider } from '../../services/Vault';
import { BrowserAuthPlugin } from '../../services/browser-auth.plugin';
import { BrowserAuthService } from '../../services/browser-auth.service';
import { LoginContainer } from '../../containers/LoginContainer';
import { getSession, getTabName } from '../../selectors/selector';
import { isMobile } from '../../utils/common';
import { store } from 'app/store';

const PrivateRoute: React.FC<any> = ({ hasSession, tab_name, component: WrappedComponent }) => {
  let browserPlugin;
  if (!isPlatform('capacitor')) {
    browserPlugin = new BrowserAuthPlugin(new BrowserAuthService());
  }
  const queryParam = new URLSearchParams(window.location.search);
  const STOF_KEY = window.sessionStorage.getItem("stateCode");
  useEffect(() => {
    if(!isMobile) {
      if(!STOF_KEY) {
        const stateCode = queryParam.get("stateCode");
        const countryCode = queryParam.get("countryCode");
        window.sessionStorage.setItem("stateCode", stateCode || "");
        window.sessionStorage.setItem("countryCode", countryCode || "");
      }
    }
  }, []);
  const vaultService = new VaultService(browserPlugin);
  const authService = AuthSingleton.getInstance(vaultService);
  return (
    <VaultProvider value={vaultService}>
      <AuthProvider value={authService}>
        <AppComponent
          authService={authService}
          Wrapper={WrappedComponent}
          vaultService={vaultService}
          sessionEval={hasSession}
          tab_name={tab_name}
        />
      </AuthProvider>
    </VaultProvider>
  );
};

const Auth: React.FC<any> = () => {
  const authWrapper = useAuthService();
  setTimeout(async () => {
    const isAuthed = await authWrapper.isAuthenticated();
    !isAuthed && await authWrapper.login();
  }, 1000);
  return null;
}
const Logout: React.FC<any> = () => {
  const authWrapper = useAuthService();
  (async () => await authWrapper.login())();
  return null;
}

type AppComponentProps = { authService: AuthenticationService, Wrapper: any, vaultService: VaultService, sessionEval: any, tab_name:any };
const AppComponent: React.FC<AppComponentProps> = observer(props => {
  let _tab = props.tab_name || "login";
  const { isLoggedIn } = props.authService;
  const STOF_KEY = window.sessionStorage.getItem("stateCode");
  const isWeb = (isPlatform('mobileweb') || isPlatform('desktop')) && !isPlatform('hybrid');
  _tab = STOF_KEY ? "stof" : _tab;

  return _tab ? (
    <IonReactRouter basename={process.env.PUBLIC_URL}>
      <Route path="/" render={() => <Redirect to="/login" />} exact />
      {isWeb && <Route path="/logout" render={() => <Logout />} exact />}
      <Route
        path="/app"
        render={() => (isLoggedIn ? <props.Wrapper {...props} /> : <Redirect to="/login" />)}
      />

      {
        <Route
          path="/login"
          render={() => (isLoggedIn ? <Redirect to={{pathname:`/app/${_tab}`, state:{direction:'none'}}} /> : (isWeb ? <Auth /> : <LoginContainer authService={props.authService}/>))}
        />
      } 
    </IonReactRouter>
  ) : null;
});

const mapStateToProps = createStructuredSelector({
  hasSession: getSession(),
  tab_name: getTabName()
});

export default connect(mapStateToProps)(PrivateRoute);